export default "__VITE_ASSET__B_9mE0k$__"